import { DummyDatabase } from './Data';


export class PortalDummyAPI {
//     // this acts as the api end point and should be replaced with the actual WebApi endpoint once the calls are ready.
//     public static GetPortalData(): IActivityThemeModel[]{
//       return DummyDatabase.GetCourseThemes();
//     }

//     public static GetCourseDetails(detailkursusId: number): IActivityModel{
//       const course =  DummyDatabase.Courses.find(c => c.detailKursusId === detailkursusId);
//       return course  ? course : DummyDatabase.Courses[0];


//     }

//     public static GetAboutPageHTML(pageId: string) : string | undefined{
//         const pageHtml = DummyDatabase.AboutPageHtml.filter(ap => ap.pageId === pageId)
//         if (pageHtml !== null && pageHtml !== undefined ){
//             return pageHtml[0].html;
//         }
//         return undefined;
//     }

    public static GetLocalUserPortalDetail(){
        return {data: DummyDatabase.UserPortalDetails};
    }

    public static GetLocalUserDetail() {
        return {data: DummyDatabase.UserDetails};
    }
    public static GetLocalPortalData(){
      return {data: DummyDatabase.PortalData};
    }

}



// WEBPACK FOOTER //
// ./src/Entities/DataDummy/DataApi.ts